module.exports = __webpack_public_path__ + "2c11d3458986cca0f9bac04446e68028.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/avenir-next-italic.ttf
// module id = 1278
// module chunks = 0